import { render } from "./AddVodModal.vue?vue&type=template&id=8e971bcc&scoped=true"
import script from "./AddVodModal.vue?vue&type=script&lang=js"
export * from "./AddVodModal.vue?vue&type=script&lang=js"

import "./AddVodModal.vue?vue&type=style&index=0&id=8e971bcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e971bcc"]])

export default __exports__